import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ItemMaintenanceComponent } from './item-maintenance.component';

const routes: Routes = [
  {
    path:'',
    component: ItemMaintenanceComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ItemMaintenanceRoutingModule { }
